import './AcBackToTopButton.scss';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { useEffect } from 'react';

/**
 * @author Shishir
 * @returns a ac style Back To Top Button
 */
export default function AcBackToTopButton() {

    const handleScrollTop = () => {
        let backToTopButton = document.querySelector('.ac-back-to-top__container');      
        let currentScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
        if (backToTopButton) {
            if((scrollHeight - currentScrollTop - window.innerHeight) < 35) {
                backToTopButton?.classList.add('ac-back-to-top__container--at-bottom');
            } else {
                backToTopButton?.classList.remove('ac-back-to-top__container--at-bottom');
            }
            if (currentScrollTop > 700) {
                backToTopButton?.classList.add('ac-back-to-top__container--show');
            } else {
                backToTopButton?.classList.remove('ac-back-to-top__container--show');
            }
        }
    }

    const scrollToTop = (e) => {
        // e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    useEffect(()=>{
        window.addEventListener("scroll", handleScrollTop);
        return () => window.removeEventListener("scroll", handleScrollTop);
    });

    return (
        <div className='ac-back-to-top__container' onClick={(e) => scrollToTop(e)}>
            <KeyboardArrowUpIcon style={{ fontSize:'48',color:'white'}} />
            <span>top</span>
        </div>
    )
}
